import iconOne from '../../assets/service/1.png';
import iconTwo from '../../assets/service/2.png';
import iconThree from '../../assets/service/3.png';
import iconFour from '../../assets/service/4.png';

const ServicesData = [
    {
        'icon': iconOne,
        'title': 'Protezler',
        'description': 'Eksik dişler için doğal görünümlü ve konforlu protez çözümleri.',
    },
    {
        'icon': iconTwo,
        'title': 'İmplantlar',
        'description': 'Kalıcı, sağlam ve estetik implant tedavileri sunuyoruz.',
    },
    {
        'icon': iconThree,
        'title': 'Beyazlatma',
        'description': 'Daha parlak ve sağlıklı bir gülüş için profesyonel beyazlatma.',
    },
    {
        'icon': iconFour,
        'title': 'Kanal Tedavisi',
        'description': 'İltihaplı dişleri korumaya yardımcı etkili kanal tedavisi.',
    }
]

export default ServicesData;